import { ChangeDetectorRef, Component, ViewRef,LOCALE_ID } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { MatListOption, MatSelectionListChange } from '@angular/material'
import { environment } from '../../../environments/environment'
import { Stringable, StringableValues } from '../../common/stringable.decorator'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { ConsultationService, DialogService, DossierService, ListeService, StateService,PageService, DocumentService } from '../../services'
import { ConfirmComponent } from '../../views/partials/layout/dialogs/confirm-dialog/confirm.component'
import { SecurityHandlerComponent } from '../dialogs/security-handler/security-handler.component'
import { NomadeService } from '../services/nomade.service'

import { DateAdapter, MatDatepickerInputEvent , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import { MAT_STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { take } from 'rxjs/operators'

const KEY = 'nomade-configurateur-component'
@Component({
	selector: 'atyl-nomade-configurateur',
	templateUrl: './configurateur.component.html',
	styleUrls: ['./configurateur.component.scss'],
	providers: [
		{
	    provide: MAT_STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
	  }	,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'nomade/configurateur/configurateur',
	key: KEY,
})
export class ConfigurateurComponent {

	@StringableValues(KEY) strings: any

	isLinear = false;
	now:Date=new Date();
	searchFormGroup: FormGroup = new FormGroup({
		nom: new FormControl(''),
		prenom: new FormControl(''),
		dateDeNaissance: new FormControl('')
	})
	
	filterConsultationsListFormGroup: FormGroup = new FormGroup({
		startDate: new FormControl(this.now),
		endDate: new FormControl('')
	})

	savedDossiers: any[] = []
	searchDossiersList: any[] = []
	selectedIndex: number = 0;

	currentUser: any
	currentUserConsultationsList: any[] = []
	savedConsultations: any[] = []
	listConsultations: any[] = []
    menus:any[]=[] 
    
	// toSaveDossiers: any[] = []
	summaryDossiers: any[] = []
	summaryConsultations: any[] = []
	maxDossiersLimit: number
	maxConsultationLimit: number

	listOfSelectedOptions: MatListOption[]

	listOfSelectedConsultations: MatListOption[]

    typeDocuments: any[] = []
    showSummaryDossier: boolean = false;
    showSummaryConsult: boolean = false;
    



	loading: boolean = false
	constructor(
		private nomadeService: NomadeService,
		private listeService: ListeService,
		private changeDetectorRef: ChangeDetectorRef,
		private stateService: StateService,
		private consultationService: ConsultationService,
		private dossierService: DossierService,
		private dialogService: DialogService,
		private pageService:PageService,
        private documentService:DocumentService
	) { }

	ngOnInit() {
		this._cleannDB();
		this.__init__menus__()
		this.__init__savedDossiers__()
		this.__init__savedConsultations__()
		this.__init__currentUser__()
		this.__init__currentUserConsultationsList__()
		this.__init__max__dossiers__()
		this.__init__max__consultations__()
        this.__init__document__types()
	}
	
    _cleannDB() {
		this.nomadeService.__clear__indexedDb__();
	}
	
	searchDossiers() {
		const dossierListKey = 'dossier'
		const _options = this.__generate__filters__()
		this.listeService.get(dossierListKey, _options).subscribe((response: JSONRpcResponse) => {
			if (response.result && response.result.datas && response.result.datas.datas) {
                //coche ceux déjà ajoutés
                response.result.datas.datas.map(dossier => {
                    if(this.summaryDossiers.find(doss => doss.ID == dossier.id)){
                        dossier.selected = true;
                    }
                });
				this.searchDossiersList = response.result.datas.datas
				this.changeDetectorRef.detectChanges()
			}
		})
	}
	saveSearchedDossiers(event: MatSelectionListChange) {
        this.listOfSelectedOptions = event.source.selectedOptions.selected
		this.listOfSelectedOptions.forEach(option => {
            const dossierId = option.value.id
			const found = this.savedDossiers.some(item => item.ID === dossierId)
			if (!found) {
				if (this.summaryDossiers.length >= this.maxDossiersLimit) {
					option.selected = false
					window.alert('Vous avez atteint le nombre maximum de dossiers')
				} else {
					this.dossierService.get(dossierId).subscribe((response: JSONRpcResponse) => {
						if (response.result) {
							this.nomadeService.addSavedDossier(response.result)
						}
						this.changeDetectorRef.detectChanges()
					})
				}
			}
		})
        if(!event.option.selected){
            var dossier = event.option.value;
            dossier.ID = dossier.id;
            this.nomadeService.removeSavedDossier(dossier)
            this.changeDetectorRef.detectChanges()
        }
        
	}
    
    
	selectConsultations(event: MatSelectionListChange) {
		this.listOfSelectedConsultations = event.source.selectedOptions.selected
		this.listOfSelectedConsultations.forEach(option => {
			const consultationId = option.value.ID
			console.log(this.savedConsultations)
			const found = this.savedConsultations.some(item => item.ID === consultationId)
			if (!found) {
				if (this.summaryConsultations.length >= this.maxConsultationLimit) {
					option.selected = false
					window.alert('Vous avez atteint le nombre maximum de consultations')
				} else {
					this.consultationService.getconsultation(consultationId).subscribe((response: JSONRpcResponse) => {
						if (response.result) {
							this.nomadeService.addSavedConsultation(response.result)
						}
						this.changeDetectorRef.detectChanges()
					})
				}
			}
		})
        if(!event.option.selected){
            var consult = event.option.value;
            this.nomadeService.removeSavedConsultation(consult)
            this.changeDetectorRef.detectChanges()
        }
	}

	saveAllAndStore(event: MouseEvent) {
		this.dialogService.open(SecurityHandlerComponent, {
			maximizable: false,
			minimizable: false,
			draggable: false,
			resizable: false,
			width: '50vw',
			height: '50vh',
		}, (_res: boolean) => {
			if (_res) {
				this.loading = true
				console.log('saveAllAndStore will be called')
				this.changeDetectorRef.detectChanges()
				this.nomadeService.saveAllAndStore()
				this.nomadeService.ready.subscribe((res: boolean) => {
					if (res) {
						this.loading = false
						this.changeDetectorRef.detectChanges()
					}
				})
			}
		})
	}
	filterConsultations(event: MouseEvent) {
		this.__init__currentUserConsultationsList__();
		/*const { startDate, endDate } = this.filterConsultationsListFormGroup.value
		this.listConsultations = this.currentUserConsultationsList.filter(consultation => {
			const startDateConsulation = new Date(consultation.date_debut)
			const endDateConsulation = new Date(consultation.date_fin)
			if (startDate) {
				return startDateConsulation >= startDate
			}
			if (endDate) {
				console.log(endDateConsulation, endDate)
				return endDateConsulation <= endDate
			}
		})*/
	}

	private __generate__filters__() {
		const searchParams = {
			datenaissance: {
				ID: 'datenaissance',
				value: this.searchFormGroup.get('dateDeNaissance').value,
			},
			nom: {
				ID: 'nom',
				value: this.searchFormGroup.get('nom').value || '',
			},
			prenom: {
				ID: 'prenom',
				value: this.searchFormGroup.get('prenom').value || '',
			},
		}
		return {
			filters: searchParams
		}
	}
	private __init__savedConsultations__() {
		this.nomadeService.savedConsultations.subscribe((consultations: any[]) => {
			this.savedConsultations = consultations
			this.summaryConsultations = consultations
			this.changeDetectorRef.detectChanges()
		})
	}
	private __init__savedDossiers__() {
		this.nomadeService.savedDossiers.subscribe(dossiers => {
			this.savedDossiers = dossiers
			this.summaryDossiers = this.savedDossiers
		})
	}
	private __init__currentUser__() {
		this.stateService.user.subscribe(user => {
			this.currentUser = user
		})
	}
	
	private __init__menus__() {
		this.menus=[];
		this.stateService.pages.pipe(
            take(1) // Take only one emission
        ).subscribe(pages => {
			let _opt:any={
				dem_form:true,
    	   	    childView: true,
    	   	    viewAllField:true
			}
			const regex = /^NOMADE_/;
			
			let pgs:any[]=[];
		
			pages.forEach((page,index) => {
				if (page.key.match(regex))
					pgs.push(page);
				
			})
			
			pgs.forEach((page,index) => {
				this.pageService.get(page.key,_opt).subscribe((response: JSONRpcResponse) => {
										 this.menus.push(response.result);
										 const last: boolean = (pgs.length - 1) == index
										if (last) {
											this.nomadeService.updateMenus(this.menus);
										}	
				})
			});
			/*
			pages.forEach((page,index) => {
				if (page.key.match(regex))
				     this.pageService.get(page.key,_opt).subscribe((response: JSONRpcResponse) => {
						 this.menus.push(response.result);
						 const last: boolean = (pages.length - 1) == index
						if (last) {
							this.nomadeService.updateMenus(this.menus);
							
						}
					})
			});
			*/
        });
	}
	
	private __init__currentUserConsultationsList__() {
		const { startDate, endDate } = this.filterConsultationsListFormGroup.value
		console.log("__init__currentUserConsultationsList__",startDate,endDate);
		this.currentUserConsultationsList=[];
		
		let _opts={
			datedebut:startDate,
			datefin:endDate
		}
		
		this.consultationService.getConsultationByTiers(this.currentUser.id,_opts).subscribe((response: JSONRpcResponse) => {
			if (response.result) {
                response.result.map(consult => {
                    if(this.summaryConsultations.find(cons=>cons.ID == consult.ID)){
                        consult.selected = true;
                    }
                });
				this.currentUserConsultationsList = response.result
				this.listConsultations = this.currentUserConsultationsList
				this.changeDetectorRef.detectChanges()
			}
		})
	}
	private __init__max__dossiers__() {
		this.maxDossiersLimit = environment.limitdossiers
	}

	private __init__max__consultations__() {
		this.maxConsultationLimit = environment.limitConsultations
	}

	remove(data: any, type: "dossier" | "consultation") {
		this.dialogService.open(ConfirmComponent, {
			maximizable: false,
			minimizable: false,
			draggable: false,
			resizable: false,
			data: {
				libelle: 'etes-vous sur de vouloir supprimer cette donnée ?',
			}
		}, (res: boolean) => {
			if (res) {
				if (type === 'dossier') {
					this.nomadeService.removeSavedDossier(data)
				} else {
					this.nomadeService.removeSavedConsultation(data)
				}
				setTimeout(() => {
					if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
						this.changeDetectorRef.detectChanges()
					}
				})
			}
		})
	}

    __init__document__types(){
        var subcribe = this.documentService.getDocumentsType("DOSSIER").subscribe((res: JSONRpcResponse) => {
            res.result.forEach(doc => {
                this.typeDocuments.push(doc.document);    
            });
            this.nomadeService.updateDocumentTypes(this.typeDocuments);
            subcribe.unsubscribe();
		})
    }
      
}
